import { render } from "./ReceivedBatches.vue?vue&type=template&id=217bd446"
import script from "./ReceivedBatches.vue?vue&type=script&lang=js"
export * from "./ReceivedBatches.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__